module.exports = __webpack_public_path__ + "assets/img/vtuber-ads2.7f56a3e8.png";